import { CircularProgress } from "@mui/material";

import wifiCheckImage from "../../Assets/Images/su-wifi-check.png";
import Card from "./card";
import HeadlineBlock from "./headline-block";
import PrimaryButton from "./primary-button";
import Tiles, { TILE_ICONS } from "./tiles";
import { UTILITY_STEPS, formatMoney } from "./utilities-config";

export default function HomeServices({ cashBack, onRequest, onLater, isLoading }) {
  return (
    <Card
      steps={UTILITY_STEPS}
      activeStep={1}
      progress={50}
      footer={
        <>
          <PrimaryButton onClick={onRequest} disabled={isLoading}>
            Request a call {isLoading ? <CircularProgress size={16} sx={{ color: "inherit" }} /> : null}
          </PrimaryButton>
          <button className="su-link" type="button" onClick={onLater} disabled={isLoading}>
            Not right now
          </button>
          <p className="su-legal">By requesting a call, you consent to sharing your information and the services you picked with MyUtilities for setup.</p>
        </>
      }
    >
      <div className="su-illustration su-illustration--power" aria-hidden="true">
        <img src={wifiCheckImage} alt="" />
      </div>
      <HeadlineBlock lines="Set up TV and internet." accent={`Get up to ${formatMoney(cashBack)}.`} sub="A concierge finds the best deal in your building." />
      <Tiles
        items={[
          { icon: TILE_ICONS.wifi, label: "Internet" },
          { icon: TILE_ICONS.tv, label: "TV" },
          { icon: TILE_ICONS.concierge, label: "Concierge setup" },
        ]}
      />
    </Card>
  );
}
